import { useEffect, useRef } from 'react'
import axios from '@utils/webRequests'
import { size } from '@styles/theme'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.bubble.css'
import 'quill-mention'

async function suggestPeople(searchTerm) {
  const usersFollowing = await axios.get('/api/my/users/im_following', { params: { term: searchTerm } }).catch(console.err)
  return usersFollowing?.data?.map((user) => ({ id: user.uuid, value: user.handle, ...user })) || []
}

// Timeout necessary to debounce mention requests
let timeout

async function renderListOfSuggestedPeople(searchTerm, renderList, mentionChar) {
  if (mentionChar === '@') {
    clearTimeout(timeout)
    timeout = setTimeout(async () => {
      const matchedPeople = await suggestPeople(searchTerm)
      renderList(matchedPeople)
    }, 250)
  }
}

const modules = {
  mention: {
    allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
    mentionDenotationChars: ['@', '#'],
    defaultMenuOrientation: 'bottom',
    source: renderListOfSuggestedPeople,
    renderItem: (user) => {
      // initial setup
      const el = document.createElement('div')
      const img = document.createElement('img')
      const nameCont = document.createElement('div')
      const displayName = document.createElement('span')
      const handle = document.createElement('span')

      // container styles
      el.style.display = 'flex'
      el.style.alignItems = 'center'
      el.style.padding = `${size(1)}`
      el.style.borderBottom = '0.5px solid rgba(125,125,125,0.6)'

      // user image
      img.setAttribute('src', user.thumbnail)
      img.style.height = size(5)
      img.style.width = size(5)
      img.style.borderRadius = '100%'
      img.style.marginRight = size(1)
      if (user?.isAvatar) img.style.filter = 'grayscale(100%) contrast(120%) brightness(65%)'

      // names container
      nameCont.style.display = 'flex'
      nameCont.style.flexDirection = 'column'
      nameCont.style.alignItems = 'flex-start'
      nameCont.style.justifyContent = 'center'

      // display name
      displayName.textContent = user.displayName
      displayName.style.fontWeight = 'bold'
      displayName.style.marginBottom = size(0.25)
      
      // handle
      handle.textContent = '@' + user.handle

      // building node
      el.appendChild(img)
      nameCont.appendChild(displayName)
      nameCont.appendChild(handle)
      el.appendChild(nameCont)

      return el
    }
  }
}

const NewPostQuill = ({ setQuillValue, setQuillLength, quillRef, setQuill }) => {

  // Focuses input on initial render, and unfocuses on exit (necessary for exit animation)
  useEffect(() => {
    quillRef.current?.focus()
    return () => quillRef.current?.blur()
  }, [])

  return (
    <ReactQuill
      ref={(node) => node && setQuill(node)}
      theme="bubble"
      id='new-post-quill-container'
      placeholder="What's happening?"
      modules={modules}
      style={{
        // Flex shrink style prevents flickering while typing.
        flexShrink: 0,
        minHeight: size(7),
      }}
      onChange={(content, delta, source, editor) => {
        if (quillRef.current && delta?.ops?.find((op) => op?.insert === '#')) {
          console.log('here in #')
          const editor = quillRef.current.editor
          const selection = editor.getSelection()
          console.log(editor.getSelection())
          const retainOrNot = (selection.index - 1) !== 0 && { retain: (selection.index - 1)  }
          const colorUpdate = { retain: 1, attributes: { color: '#6A23FF' } }
          const delta = retainOrNot ? [retainOrNot, colorUpdate] : [colorUpdate]
          editor.updateContents(delta)
        } else if (quillRef.current && delta?.ops?.find((op) => (op?.insert === ' ' && op?.attributes?.color))) {
          console.log('here in space')
          const editor = quillRef.current.editor
          const selection = editor.getSelection()
          const retainOrNot = (selection.index - 1) !== 0 && { retain: (selection.index - 1)  }
          const colorUpdate = { retain: 1, attributes: { color: null } }
          const delta = retainOrNot ? [retainOrNot, colorUpdate] : [colorUpdate]
          editor.updateContents(delta)
        }
        // else if (quillRef.current && delta?.ops?.find((op) => op?.insert === '\n')) {
        //   const editor = quillRef.current.editor
        //   const selection = editor.getSelection()
        //   const retainOrNot = (selection.index - 1) !== 0 && { retain: (selection.index - 1)  }
        //   const colorUpdate = { retain: 1, attributes: { color: '' } }
        //   const delta = retainOrNot ? [retainOrNot, colorUpdate] : [colorUpdate]
        //   editor.updateContents(delta)
        // }
        setQuillValue(editor.getContents())
        setQuillLength(editor.getLength())
      }}
    />
  )
}

export default NewPostQuill
